// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a4ddbf7","867":"9447b3d2"}[chunkId] + ".chunk.js";
};